import { render, staticRenderFns } from "./departmentListSection.vue?vue&type=template&id=79b9b703&scoped=true"
import script from "./departmentListSection.vue?vue&type=script&lang=js"
export * from "./departmentListSection.vue?vue&type=script&lang=js"
import style0 from "./departmentListSection.vue?vue&type=style&index=0&id=79b9b703&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b9b703",
  null
  
)

export default component.exports